import { LOGO_URL } from "../lib/api";

export function BrandLogo({ size = 56, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="TSU-PARTNERS"
      width={size}
      height={size}
      className={`object-contain rounded-xl ${className}`}
      data-testid="tsu-logo"
    />
  );
}

export function BrandMark({ className = "" }) {
  return (
    <div className={`flex items-center gap-2 sm:gap-3 min-w-0 ${className}`}>
      <img
        src={LOGO_URL}
        alt="TSU-PARTNERS"
        className="w-8 h-8 sm:w-10 sm:h-10 object-contain rounded-lg shrink-0"
        data-testid="tsu-logo"
      />
      <div className="flex flex-col leading-tight min-w-0">
        <span className="font-display font-black text-sm sm:text-base text-slate-900 tracking-tight truncate">TSU-PARTNERS</span>
        <span className="hidden sm:inline text-[10px] uppercase tracking-[0.2em] text-slate-600 truncate">Fahrer-Community</span>
      </div>
    </div>
  );
}
